import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CorporateRegistrationApprovalModel } from 'src/app/models/corporate-registration-approval.model';
import { CorporateRegistrationApprovalService } from 'src/app/services/corporate-registration-approval.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-corporate-registration-approval',
  standalone: false,
  templateUrl: './corporate-registration-approval.component.html',
  styleUrl: './corporate-registration-approval.component.scss',
})
export class CorporateRegistrationApprovalComponent {
  registration: CorporateRegistrationApprovalModel | null = null;

  constructor(
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private approvalService: CorporateRegistrationApprovalService,
    private toastrService: ToastrService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    const approvalId = this.route.snapshot.paramMap.get('approvalId');

    if (!approvalId) {
      return;
    }

    this.loadApproval(approvalId);
  }

  private loadApproval(approvalId: string): void {
    this.loadingService.load(
      this.approvalService.getApproval(approvalId)
    ).subscribe({
      next: (registration) => {
        this.registration = registration;
      },
    });
  }

  approve(): void {
    if (!this.registration) {
      return;
    }

    this.loadingService.load(
      this.approvalService.approve(this.registration.id)
    ).subscribe({
      next: () => {
        this.toastrService.success(
          this.translateService.instant(
            'CORPORATE-REGISTRATION-APPROVALS.APPROVE-SUCCESS'
          )
        );
        this.registration = null;
      },
    });
  }

  reject(): void {
    if (!this.registration) {
      return;
    }

     this.loadingService.load(
      this.approvalService.reject(this.registration.id)
    ).subscribe({
      next: () => {
        this.toastrService.success(
          this.translateService.instant(
            'CORPORATE-REGISTRATION-APPROVALS.REJECT-SUCCESS'
          )
        );
        this.registration = null;
      },
    });
  }
}
